import React from "react";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import FindAppointment from "./FindAppointment";
import RescheduleAppointment from "./RescheduleAppointment";

function ChangeAppointment() {

    return(
        <>

        <div className="container">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Nav className="cartNav">
                    <Nav.Item>
                    <Nav.Link eventKey="first">find appointment</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                    <Nav.Link eventKey="second">reschedule appointment</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                    <Nav.Link eventKey="third">reschedule summary</Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <FindAppointment/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                       <RescheduleAppointment/>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                       3
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>

        </>
    )
}

export default ChangeAppointment;